import React, { FC } from 'react';
import { Link } from 'react-router';
import { Breadcrumbs, Faq, HeroImage } from '../../customFrontend/parts';
import { SiteManifest, SiteManifestPage } from '../../customFrontend/types';
import { CityPills, Cta, SiteFooter } from './Chrome';
import { CITIES, CityContent } from './cities';

interface Props {
  site: SiteManifest;
  page: SiteManifestPage;
  city: CityContent;
}

const CityPage: FC<Props> = ({ site, page, city }) => (
  // Every other city puts its portrait on the left (wide screens)
  <>
    <section className={`mf-hero mf-hero--city mf-hero--${city.slug}${Object.keys(CITIES).indexOf(city.path) % 2 ? ' mf-hero--flip' : ''}`}>
      <div className="container mf-city-grid">
        <figure className="mf-portrait">
          <span className="mf-sun" aria-hidden="true" />
          <HeroImage page={page} className="mf-portrait-img" />
        </figure>
        <div className="mf-city-text">
          <Breadcrumbs items={[{ label: site.homeBreadcrumb ?? 'Home', to: '/' }, { label: page.breadcrumb ?? city.name }]} />
          <p className="mf-eyebrow">{city.kicker}</p>
          <h1>{city.h1}</h1>
          <Cta>{city.cta.button}</Cta>
        </div>
      </div>
    </section>

    <article className="mf-section mf-city-article">
      <div className="container mf-narrow">
        <div className="mf-intro">{city.intro}</div>
        {city.sections.map((section) => (
          <section key={section.title} className="mf-city-section">
            <h2>{section.title}</h2>
            {section.body}
          </section>
        ))}
      </div>
    </article>

    <section className="mf-section mf-section--sand">
      <div className="container mf-narrow">
        <Faq title={`Mature chat in ${city.name}: your questions`} items={city.faq} />
      </div>
    </section>

    <section className="mf-final">
      <div className="container">
        <h2>{city.cta.title}</h2>
        <p>{city.cta.text}</p>
        <Cta light>{city.cta.button}</Cta>
      </div>
    </section>

    <section className="mf-section">
      <div className="container">
        <h2 className="text-center">More of Australia on MatureFlirt</h2>
        <CityPills exclude={city.path} />
        <p className="mf-back-home">
          <Link to="/">Back to MatureFlirt: mature chat across Australia</Link>
        </p>
      </div>
    </section>

    <SiteFooter site={site} />
  </>
);

export default CityPage;
